<template>
  <d2-container>
      <el-form
        :model="form"
        ref="form"
        size="small"
        label-width="180px"
      >
        <el-form-item
                      prop="agentname"
                      label="店铺名称"
                      :rules="[{ required: true, message: '不能为空'}]"
        >
          <el-input v-model="form.agentname"></el-input>
        </el-form-item>

        <el-form-item label="店铺头像" prop="agentlogo">
          <el-input v-model="form.agentlogo" style="display:none"></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove"
                  :on-success="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
          建议尺寸1000*600像素，大小1M以内，支持jpg、png、jpeg格式
        </el-form-item>

        <el-form-item
                prop="compaddress"
                label="详细地址"
                :rules="[{ required: true, message: '不能为空'}]"
        >
          <el-input v-model="form.compaddress"></el-input>
        </el-form-item>
          <el-form-item
                  prop="shop_tel"
                  label="常用电话"
                  :rules="[{ required: true, message: '不能为空'}]"
          >
            <el-input v-model="form.shop_tel"></el-input>
        </el-form-item>
        <el-form-item
                prop="per_capita"
                label="人均消费"
                :rules="[{ required: true, message: '不能为空'}]"
        >
          <el-input v-model="form.per_capita"></el-input>
        </el-form-item>
        <el-form-item
                prop="gyj_discount"
                label="鼓励金折扣（折扣）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input  @keyup.native="changeAmount" v-model="form.gyj_discount"></el-input>
        </el-form-item>
        <el-form-item
                prop="dpfw"
                label="店铺服务"
        >
          <el-checkbox v-model="form.is_balcony">包厢</el-checkbox>
          <el-checkbox v-model="form.is_discount">折扣</el-checkbox>
          <el-checkbox v-model="form.is_children_seat" >儿童坐</el-checkbox>
          <el-checkbox v-model="form.is_subscribe" >免预约</el-checkbox>
          <el-checkbox v-model="form.is_wifi" >WIFI</el-checkbox>
          <el-checkbox v-model="form.is_tea_water" >茶水</el-checkbox>
          <el-checkbox v-model="form.is_stop" >停车场</el-checkbox>
          <el-checkbox v-model="form.is_sofa" >沙发</el-checkbox>

        </el-form-item>
        <el-form-item
                prop="business_hours"
                label="是否二十四小时"
        >
          <el-radio v-model="form.business_hours" label="true">是</el-radio>
          <el-radio v-model="form.business_hours" label="false">否</el-radio>
        </el-form-item>
        <el-form-item
                prop="start_time"
                label="营业开始时间"
        >

          <el-time-picker
                  v-model="form.start_time"
                  format="HH:mm"
                  :picker-options="pickerOptions" value-format="HH:mm">
          </el-time-picker>

        </el-form-item>
        <el-form-item
                prop="end_time"
                label="营业结束时间"
        >
          <el-time-picker
                  v-model="form.end_time"
                  format="HH:mm"
                  :picker-options="pickerOptions" value-format="HH:mm">
          </el-time-picker>
        </el-form-item>
        <el-form-item
                prop="shop_introduction"
                label="店铺介绍"
        >
          <el-input  type="textarea"   placeholder="本店经营:快餐、订餐、聚合、生日宴、酒席" v-model="form.shop_introduction"></el-input>
        </el-form-item>
        <el-form-item
                prop="shop_reminder"
                label="店铺提示"
        >
          <el-input  type="textarea"  placeholder="进店消费、如有不满意、可以免费" v-model="form.shop_reminder"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
                  type="primary"
                  :loading="loading"
                  @click="saveUser"
          >保存</el-button>
        </el-form-item>
      </el-form>

  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
export default {
  name: "ShopsPage",
  components: { },
  data() {
    return {
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        pickerOptions: {}, // 日期设置对象
        loading: false,
        fileList: [],
        form: {
            dpfw:[],
            business_hours: "否",
          userCode: ""
      }
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      changeAmount () {
          this.form.gyj_discount = this.form.gyj_discount.replace(/[^\d.]/g, '')
      },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 文件超出个数限制时的钩子
      handleExceed(files, fileList) {

      },
      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
          this.form.agentlogo ="";
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
          console.log("url==="+file.url);
          this.form.agentlogo = file.url;
      },

      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  this.loading = true;
                  agentService.saveMyshops({ ...this.form,agentid:util.cookies.get('agentid')})
                      .then(data => {
                          this.loading = false;
                      });


              } else {
                  return false;
              }
          });
      },
    getTableData() {
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",util.cookies.get('agentid'));
        agentService.getAgentXq(formData4).then(data => {
            if(data!=null && data!=""){

                let form = {};

                form.agentname=data.agentname;

                if(data.agentlogo!=null && data.agentlogo!="") {
                    form.agentlogo = data.agentlogo;
                    this.fileList = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' +  data.agentlogo}]
                }


                form.compaddress=data.compaddress;
                form.shop_tel=data.shop_tel;
                form.per_capita=data.per_capita;
                if(data.is_balcony=="是")
                form.is_balcony=true;
                if(data.is_discount=="是")
                form.is_discount=true;
                if(data.is_children_seat=="是")
                form.is_children_seat=true;
                if(data.is_subscribe=="是")
                form.is_subscribe=true;
                if(data.is_wifi=="是")
                form.is_wifi=true;
                if(data.is_tea_water=="是")
                form.is_tea_water=true;
                if(data.is_stop=="是")
                form.is_stop=true;
                if(data.is_sofa=="是")
                form.is_sofa=true;


                form.business_hours=data.business_hours;

                form.start_time=data.start_time;
                form.end_time=data.end_time;
                form.shop_introduction=data.shop_introduction;
                form.shop_reminder=data.shop_reminder;
                form.gyj_discount=data.gyj_discount;
                this.form = form;
            }
        });
    }

  }
};
</script>
